// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9988) return "static/chunks/9988-a138f59304d90c82.js";
	if (chunkId === 3639) return "static/chunks/3639-770eb3d51d4127a5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1331":"a99f4dcc574d1824","2848":"461aff1818909490","4907":"cc79f98a79135297","5492":"ec5c11a9de0cca3a","5497":"f80759c156f4b8d8","6234":"e33310f0ff790bf2"}[chunkId] + ".js";
};